var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKerningIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9576",
    "data-name": "Group 9576",
    transform: "translate(821.98 22860)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27463",
    "data-name": "Path 27463",
    d: "M138.02,11a1,1,0,0,0,1-1V7h3v3a1,1,0,0,0,2,0V4.5a3.5,3.5,0,0,0-7,0V10a1,1,0,0,0,1,1m1-6.5a1.5,1.5,0,0,1,3,0V5h-3Z",
    transform: "translate(-959 -22861)",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27464",
    "data-name": "Path 27464",
    d: "M148.083,10.352a1,1,0,0,0,1.873,0l3-8a1,1,0,1,0-1.873-.7l-2.063,5.5-2.064-5.5a1,1,0,0,0-1.873.7Z",
    transform: "translate(-959 -22861)",
    fill: "#991F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27465",
    "data-name": "Path 27465",
    d: "M152.726,15.292l-2-2a1,1,0,1,0-1.414,1.414l.293.293h-9.172l.293-.293a1,1,0,0,0-1.414-1.414l-2,2a1,1,0,0,0-.218,1.09,1.008,1.008,0,0,0,.218.327l2,2a1,1,0,0,0,1.414-1.414L140.434,17h9.172l-.293.293a1,1,0,1,0,1.414,1.414l2-2a1.005,1.005,0,0,0,.217-1.09.984.984,0,0,0-.217-.327",
    transform: "translate(-959 -22861)",
    fill: "#991F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKerningIconSelected);
export default __webpack_public_path__ + "static/media/KerningIconSelected.2fc0a6551fe8e7da0c5e7e4d19085bef.svg";
export { ForwardRef as ReactComponent };